import styled, { css } from "styled-components";

export const CheckboxGridRow = styled.div`
  column-count: 4;
`;

export const DepartmentCountText = styled.span`
  font-size: 14px;
  color: #767676;
  font-style: italic;
  float: right;
`;
